import React from 'react';
import cn from 'classnames';
import {StandardProps} from '..';

type DialogSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

function getDialogWidth(size?: DialogSize): number | string {
  switch (size) {
    case 'xxs':
      return 400;
    case 'xs':
      return 512;
    case 'sm':
      return 600;
    case 'md':
      return 800;
    case 'lg':
      return 1000;
    case 'xl':
      return 1200;
  }
  return 'auto'; // auto
}

export interface DialogContentProps extends StandardProps {
  test?: string;
  size?: DialogSize;
}

export const DialogContent: React.FC<DialogContentProps> = ({
  children,
  className,
  style,
  ...restProps
}) => {
  return (
    <div
      className={cn('dialog__content px-5 px-sm-6 flex-fill overflow-y-auto', className)}
      style={{width: getDialogWidth(restProps.size), ...style}}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default DialogContent;
